import {
    SearchableSelect,
    SearchableSelectWrapperProps,
} from "components/UI/Selects/SearchableSelect/SearchableSelect.tsx";
import { useTriggerSelectOptions } from "components/UI/Selects/TriggerSelectSearchable/useTriggerSelectOptions.ts";

export const TriggerSelectSearchable = (props: SearchableSelectWrapperProps) => {
    const hookResult = useTriggerSelectOptions();

    return (
        <SearchableSelect
            hookResult={hookResult}
            translationNamespace="forms.general-fields.trigger"
            {...props}
            size={props.size ?? "middle"}
        />
    );
};
